import React from 'react';
import { makeContentfulAsset, ContentfulImage, lightCaptionStyle, } from '../../../features/ui/Contentful';
import { isContentfulImage } from '../utils';
import { DefaultRenderer } from './DefaultRenderer';
import { ImageAspectBox16x9 } from '../Components/ImageAspectBox/ImageAspectBox';
import { renderToString } from 'react-dom/server';
import qs from 'query-string';
import styled from 'styled-components';
import { cssSpacing, headlineLarge } from '@spotify-internal/encore-web';
const maxWidth = '680px';
const dropCapStyle = `
  padding-left: ${cssSpacing('tighter-2')};
  padding-bottom: 0px;
  padding-right: ${cssSpacing('tighter-2')};
  float: left;
  position: relative;
  top: ${cssSpacing('tighter-2')};
  margin-bottom: ${cssSpacing('tighter-2')};
  margin-left: ${cssSpacing('tighter-2')};
  margin-right: ${cssSpacing('tighter-2')};
  font-size: ${headlineLarge.fontSize};
  font-weight: ${headlineLarge.fontWeight};
  font-family: ${headlineLarge.fontFamily};
`;
const DropCap = styled.p `
  max-width: ${maxWidth};
  margin: auto;
  &:first-letter {
    ${dropCapStyle}
  }
`;
export const renderYoutubeVideoParagraph = (text) => {
    const isVideo = text.indexOf('[youtube-video') === 0;
    if (!isVideo) {
        return text;
    }
    const url = getVideoUrl(text);
    function videoId(videoUrl) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = videoUrl.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
    }
    const embedUrl = `https://www.youtube.com/embed/${videoId(url)}?${qs.stringify({
        autoplay: 0,
        iv_load_policy: 3,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
    })}`;
    const params = {};
    const fullWidth = text.indexOf('[youtube-video-full') === 0;
    if (fullWidth)
        params.style = { maxWidth: 'unset' };
    const frame = (React.createElement("iframe", { title: "video", src: embedUrl, frameBorder: "0", allowFullScreen: true, allow: "encrypted-media", ...params }));
    if (url) {
        return renderToString(React.createElement(ImageAspectBox16x9, { "data-testid": "video-component", style: params.style }, frame));
    }
    return '';
};
export class ArticleRenderer extends DefaultRenderer {
    constructor() {
        super(...arguments);
        this.pNum = 0;
        this.initialDropcap = false;
    }
    image(href, title, text) {
        const fullWidth = (text || '').indexOf('full-width') > -1;
        const isContentfulImg = isContentfulImage(href);
        if (isContentfulImg && !fullWidth) {
            const bits = href.split('.');
            const contentType = `image/${bits[bits.length - 1].replace('jpg', 'jpeg')}`;
            const asset = makeContentfulAsset({
                url: href,
                contentType,
                description: title || text,
            });
            return renderToString(React.createElement(ContentfulImage, { asset: asset, caption: text, captionStyle: lightCaptionStyle }));
        }
        const txt = (text || '').replace('full-width', '');
        const imageHtml = renderToString(React.createElement("img", { src: href, alt: title }));
        return `
      <figure>
        ${imageHtml}
        ${renderToString(React.createElement("figcaption", { style: lightCaptionStyle }, txt))}
      </figure>
    `;
    }
    paragraph(text) {
        if (text && !text.startsWith('[')) {
            this.pNum++;
        }
        let renderedText = text;
        if (text &&
            text.length > 1 &&
            (text.startsWith('^') ||
                (this.pNum === 1 && this.initialDropcap && /^[a-zA-Z\"]/.test(text)))) {
            renderedText = renderToString(React.createElement(DropCap, { dangerouslySetInnerHTML: { __html: text.replace(/^\^/, '') } }));
        }
        renderedText = renderYoutubeVideoParagraph(renderedText);
        return super.paragraph(renderedText);
    }
}
function getVideoUrl(text) {
    try {
        const [, , videoId] = /\[(youtube-video|youtube-video-full)\s+([\w-_]+)?\]/gi.exec(text);
        return `https://www.youtube.com/embed/${videoId}?iv_load_policy=3&playsinline=1&rel=0`;
    }
    catch (e) {
        console.error(e);
        return '';
    }
}
